import React from "react";
import Skeleton from "react-loading-skeleton";
import PrismancyLogo from "./PrismancyLogo";
import useWorkspace from "../hooks/workspace/useWorkspace";
import IconFont from "../elements/IconFont";
import Drawer from "./Drawer";
import { PanelLeft } from "lucide-react";

interface AuthenticatedHeaderProps {
  isDesktopSidebarCollapsed: boolean;
  onToggleDesktopSidebar: () => void;
}

function AuthenticatedHeader({
  isDesktopSidebarCollapsed,
  onToggleDesktopSidebar,
}: AuthenticatedHeaderProps) {
  const { workspace, isLoading } = useWorkspace();

  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);

  const handleToggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  return (
    <div className="ui-panel-header ui-layer-header relative flex h-16 w-full items-center border-b border-border-default px-[28px]">
      {/* Left - menu button */}
      <div className="flex items-center gap-[8px]">
        <button
          onClick={handleToggleDrawer}
          type="button"
          className="ui-auth-header-menu-trigger btn-icon relative h-8 w-8 p-0"
          aria-label="Open menu"
          aria-expanded={openDrawer}
        >
          <PrismancyLogo variant="icon" className="ui-auth-header-menu-logo" />
          <PanelLeft
            aria-hidden="true"
            size={22}
            className="ui-auth-header-menu-icon"
          />
        </button>
        <Drawer
          isOpen={openDrawer}
          onClose={handleCloseDrawer}
          isDesktopCollapsed={isDesktopSidebarCollapsed}
          onToggleDesktopCollapsed={onToggleDesktopSidebar}
        />
      </div>

      {/* Right - workspace name */}
      <div className="relative ml-auto flex max-w-[calc(50%-56px)] min-w-0 items-center gap-[4px] leading-[1] group sm:max-w-[200px]">
        <IconFont name="layers-2" size={16} className="shrink-0" />
        <span className="block min-h-[15px] min-w-0 flex-1 cursor-pointer overflow-hidden truncate text-ellipsis whitespace-nowrap text-sm text-heading">
          {isLoading ? <Skeleton width={80} /> : workspace?.name}
        </span>
        <span className="ui-layer-tooltip absolute top-full mt-2 invisible whitespace-nowrap rounded-[6px] border border-border-default bg-background-surface-02 p-2 text-heading shadow-sm group-hover:visible">
          {isLoading ? <Skeleton /> : workspace?.name}
        </span>
      </div>
    </div>
  );
}

export default AuthenticatedHeader;
